/**
 * Argus — helpers pentru device_events timeline (continuous-monitoring-usb).
 *
 * Bloc continuous-monitoring-usb 2026-05-06.
 */

import { apiFetch } from './api';

export type DeviceEventType = 'usb_connected' | 'usb_disconnected' | 'drive_mounted' | 'drive_unmounted';

export const DEVICE_EVENT_TYPES: readonly DeviceEventType[] = [
  'usb_connected',
  'usb_disconnected',
  'drive_mounted',
  'drive_unmounted',
];

export interface DeviceEventItem {
  readonly id: number;
  readonly event: DeviceEventType;
  readonly vid: string | null;
  readonly pid: string | null;
  readonly serial: string | null;
  readonly friendlyName: string | null;
  readonly deviceClass: string | null;
  readonly driveLetter: string | null;
  readonly filesystem: string | null;
  readonly label: string | null;
  readonly sizeBytes: number | null;
  readonly freeBytes: number | null;
  readonly byUser: string | null;
  readonly capturedAt: string;
}

export interface DeviceEventsResponse {
  readonly agentId: string;
  readonly items: readonly DeviceEventItem[];
  readonly nextCursor: number | null;
  readonly limit: number;
}

export interface DeviceEventsQuery {
  readonly event?: readonly DeviceEventType[];
  readonly serial?: string;
  readonly from?: string;
  readonly to?: string;
  readonly cursor?: number;
  readonly limit?: number;
}

export async function fetchDeviceEvents(
  agentId: string,
  query: DeviceEventsQuery = {}
): Promise<DeviceEventsResponse> {
  const qs = new URLSearchParams();
  if (query.event && query.event.length > 0) qs.set('event', query.event.join(','));
  if (query.serial) qs.set('serial', query.serial);
  if (query.from) qs.set('from', query.from);
  if (query.to) qs.set('to', query.to);
  if (query.cursor !== undefined && query.cursor > 0) qs.set('cursor', String(query.cursor));
  if (query.limit) qs.set('limit', String(query.limit));
  const suffix = qs.toString() === '' ? '' : `?${qs.toString()}`;
  const result = await apiFetch<DeviceEventsResponse>(
    `/api/v1/agents/${agentId}/device-events${suffix}`
  );
  return result.data;
}

/** Server WS push payload (continuous-monitoring-usb). */
export interface DeviceEventPushPayload {
  readonly type: 'device_event_push';
  readonly agentId: string;
  readonly hostname: string | null;
  readonly event: DeviceEventType;
  readonly vid: string | null;
  readonly pid: string | null;
  readonly serial: string | null;
  readonly friendlyName: string | null;
  readonly deviceClass: string | null;
  readonly driveLetter: string | null;
  readonly filesystem: string | null;
  readonly label: string | null;
  readonly sizeBytes: number | null;
  readonly freeBytes: number | null;
  readonly byUser: string | null;
  readonly capturedAt: string;
}

export const DEVICE_EVENT_CUSTOM_EVENT = 'argus:device-event';

export const DEVICE_EVENT_LABEL: Record<DeviceEventType, string> = {
  usb_connected: 'USB conectat',
  usb_disconnected: 'USB deconectat',
  drive_mounted: 'Drive montat',
  drive_unmounted: 'Drive demontat',
};
